module.exports = __webpack_public_path__ + "static/img/v4_1.00e77442.png";